import { notification } from 'antd';
import axios from 'axios';
import putSignature from './putSignature';
import { useUserDataStore } from '../shared/store';
// API constants
export const APIUrl = process.env.REACT_APP_SOLIQ_BASE_URL;

export let request = axios.create({
  baseURL: APIUrl,
  Accept: 'Application/json',
  'Content-Type': 'Application/json',
});
request.interceptors.request.use((config) => {
  const { soliqAccessToken, accessToken } = useUserDataStore.getState();
  config.headers = Object.assign({
    ...config.headers,
  });

  if (accessToken && soliqAccessToken) {
    config.headers = Object.assign({
      ...config.headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
      Token: soliqAccessToken ? `${soliqAccessToken}` : '',
      'Content-Type': 'Application/json',
    });
  }
  return config;
});

request.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    if (error?.response?.status === 401) {
      const sellerKey = JSON.parse(localStorage.getItem('selectedECP'));
      const data = { tin: sellerKey?.TIN, inn: sellerKey?.TIN };
      const sign = await putSignature(data, sellerKey);
      const resSoliq = await soliqRequest.Soliq.login({ sign: sign });
      localStorage.setItem('soliqToken', resSoliq?.data?.token?.access_token);
      window.location.reload();
      // notifications.show({
      //   message: error?.response?.data?.message || "error",
      //   color: "red",
      // })
    } else {
      notification.open({ message: error?.response?.data?.data || 'error' });
    }
  }
);

export const soliqRequest = {
  Soliq: {
    login: (data) => request.post('/login-tin', data),

    getInfo: (inn) => request.get(`/np1/bytin/factura?tinOrPinfl=${inn}`),

    waybill2: (data) => request.post('/waybill2', data),
    waybill2Cancel: (tin, data) => request.post(`/waybill2-cancel?tin=${tin}`, data),
    getWaybill: (id) => request.get(`/waybill2/${id}`),

    contract: (data) => request.post('/contract', data),
    contractCancel: (tin, data) => request.post(`/contract/cancel-by-owner?tin=${tin}`, data),
    getContract: (id) => request.get(`/contract/${id}`),

    factura: (data) => request.post('/factura', data),
    facturaSave: (data) => request.post('/factura-save', data),
    getFactura: (id) => request.get(`/factura/${id}`),
    facturaCancel: (tin, data) => request.post(`/factura-cancel?tin=${tin}`, data),

    empowerment: (tin, data) => request.post(`/empowerment/seller?tin=${tin}`, data),
    getEmpowerment: (id) => request.get(`/empowerment/${id}`),

    bank: (mfo) => request.get(`/bank/${mfo}`),
    guid: () => request.get('/utils/guid'),
    tasnif: (tin = '', search = '') => request.get(`/tasnif/product?tin=${tin || 311053656}&search=${search}`),
    tasnifAll: (text) =>
      axios.get(`https://tasnif.soliq.uz/api/cls-api/elasticsearch/search?lang=uz_latn&search=${text}&size=20&page=0`),
  },
};
